import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { DocumentViewerService } from '../document-viewer.service';
import { DocumentFileType } from '../document-file-type.enum';
import { ImageConverterService } from '../../document-shared/image-converter.service';
import { CommonModule } from '@angular/common';
import { PdfViewerComponent } from '../file-viewers/pdf-viewer/pdf-viewer.component';
import { ImageViewerComponent } from '../file-viewers/image-viewer/image-viewer.component';

@Component({
  selector: 'app-document-viewer',
  templateUrl: './document-viewer.component.html',
  styleUrls: ['./document-viewer.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    PdfViewerComponent,
    ImageViewerComponent,
  ],
})
export class DocumentViewerComponent implements OnChanges {
  private service = inject(DocumentViewerService);
  private imageConverter = inject(ImageConverterService);

  @Input() documentId: number;
  @Output() download: EventEmitter<any> = new EventEmitter();
  totalPages = 1;

  // used to pass down to PDF Viewer
  document: Blob;
  // used to pass down to Image Viewer
  imgUrl: string;

  documentType: DocumentFileType;
  fileIndex = 0;

  loaded = false;

  
 

  

  ngOnChanges(changes: SimpleChanges) {
    if (changes.documentId && !isNaN(this.documentId)) {
      this.fileIndex = 0;
      this.loadDocument();
    }
  }

  loadDocument() {
    this.service.getDocumentMetadata(this.documentId).subscribe(result => {
      this.totalPages = result.totalPages;
    });

    this.service.getDocumentPreview(this.documentId, this.fileIndex).subscribe(async result => {
      const contentType = result.headers.get('content-type');

      switch (contentType) {
        case 'application/pdf':
          this.document = result.body;
          this.documentType = DocumentFileType.PDF;
          this.loaded = true;
          break;
        case 'image/tiff':
          this.documentType = DocumentFileType.Image;
          this.imgUrl = await this.imageConverter.convertTiffToCanvasImg(result.body);
          this.loaded = true;
          break;
        case 'image/jpeg':
        case 'image/png':
          this.documentType = DocumentFileType.Image;
          this.imgUrl = URL.createObjectURL(result.body);
          this.loaded = true;
          break;
        default:
          this.documentType = DocumentFileType.Unsupported;
          this.loaded = true;
          break;
      }
    });
  }

  loadPage(index: number): void {
    this.fileIndex = index;
    this.loadDocument();
  }

  downloadClick(): void {
    this.download.emit(null);
  }
}
